export default class ValidationError extends Error {
  constructor(fieldErrors, error) {
    super(error || 'Form error')
    this.fieldErrors = fieldErrors
  }
}
